import(/* webpackMode: "eager" */ "/home/u650493134/domains/kelolify.com/hbuilds/source/repository/src/app/global-error.tsx");
